import { Vue, Component} from 'vue-property-decorator'

@Component({
    name: 'site-footer',
})
export default class SiteFooter extends Vue {
}

